import type { DialogApiInjection } from 'naive-ui/es/dialog/src/DialogProvider'
import type { MessageApiInjection } from 'naive-ui/es/message/src/MessageProvider'

export const GlobalThis: {
  $message: MessageApiInjection | undefined
  $dialog: DialogApiInjection | undefined
  $appScrollContainer: HTMLElement | undefined
  $memberModal: any
  $buyModal: any
  $loginModalNew: any
  $loginPrompt: any
  $LoginPopTips: any
  $topUpModal: any
  $depositModal: any
  $dropdownMenu: any
  $tabbar: any
  $decentralScroll: any
  $postViewModal: any
  $postViewPhoneModal: any
  $applyApprovedModal: any
  $musicPlayer: any
  $globalAlert: any
  $uploadLeaveConfirmModalRef: any
  $globalMask: any
  $welcome: any
  $insufficientFunds: any
  $getRewards: any
  $leaveConfirmModal: any
  $payIframe: any
  $creditCardModal: any
  $topUpFirst: any
  $paySuccess: any
  $payTopUp: any
  $paypalModal: any
  $payMask: any
  $ccBillModal: any
} = {
  $message: undefined,
  $dialog: undefined,
  $appScrollContainer: undefined,
  $memberModal: undefined,
  $buyModal: undefined,
  $loginModalNew: undefined,
  $loginPrompt: undefined,
  $LoginPopTips: undefined,
  $topUpModal: undefined,
  $depositModal: undefined,
  $dropdownMenu: undefined,
  $tabbar: undefined,
  $decentralScroll: undefined,
  $postViewModal: undefined,
  $postViewPhoneModal: undefined,
  $applyApprovedModal: undefined,
  $musicPlayer: undefined,
  $globalAlert: undefined,
  $uploadLeaveConfirmModalRef: undefined,
  $globalMask: undefined,
  $welcome: undefined,
  $insufficientFunds: undefined,
  $getRewards: undefined,
  $leaveConfirmModal: undefined,
  $payIframe: undefined,
  $creditCardModal: undefined,
  $topUpFirst: undefined,
  $paySuccess: undefined,
  $payTopUp: undefined,
  $paypalModal: undefined,
  $payMask: undefined,
  $ccBillModal: undefined,
}
